// extracted by mini-css-extract-plugin
export default {"informer":"DocumentsInformer__informer--1qzVu","icon":"DocumentsInformer__icon--3uN4p"};